import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {GenericLinkedResource, GenericSelfInfo} from '@catcore/types/base';
import {extractDataFromModel, extractDataFromProperty} from '@catcore/utils';
import {ProjectFeature} from '@catmodules/models/project-feature/types';
import {ProjectUnit} from '@catmodules/models/project-units/types';
import {Restangular} from 'ngx-restangular';
import {isNullOrUndefined} from 'util';

/**
 * Service to manage all things around a ProjectFeature
 */
@Injectable()
export class ProjectFeatureService extends RestHttpService<ProjectFeature> {

  constructor(service: Restangular) {
    super('project-features', service);
  }

  extractUnitsFor(feature: ProjectFeature): GenericLinkedResource[]{
    return extractDataFromModel<ProjectFeature>(feature, 'units');
  }

  extractServicesFor(feature: ProjectFeature): GenericLinkedResource[]{
    return extractDataFromModel<ProjectFeature>(feature, 'services');
  }

  updateFromFeature(id: any) {
    return this.getRawSubresource(id, 'update');
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-feature/services/project-feature.service.ts